import { gql } from '@common/hooks';

const OrganizationUnitsClinicalUnits = gql`
  query WorksOrganizationUnits {
    organizationUnits {
      id
      name
      costCenter
      clinicalUnit {
        id
        displayName
      }
    }
  }
`;

export { OrganizationUnitsClinicalUnits };
